import { DataVizConfig, DataVizType } from '../types';
import { actions, feedback, elements } from '@ecosystem/newron-design-system';
import React, { cloneElement } from 'react';

const { Icon } = elements;
const { ToggleButtons } = actions;
const { Tooltip } = feedback;

const iconMap: Record<DataVizType, JSX.Element> = {
  table: <Icon.icons.Table />,
  chart: <Icon.icons.BarChartVert />,
  horizontalBarChart: <Icon.icons.BarChartHoriz />,
  stackedBarChart: <Icon.icons.BarChartVert />,
  lineChart: <Icon.icons.LineChart />,
  verticalBarChart: <Icon.icons.BarChartVert />,
  bubbleChart: <Icon.icons.BubbleChart />,
  valueWithChangeChart: <Icon.icons.BarChartVert />,
};

type Props = {
  options: DataVizConfig[];
  value: DataVizType;
  onChange: (value: DataVizType) => void;
};

function DataVizToggle({ options, value, onChange }: Props) {
  if (!options.length) {
    return null;
  }

  return (
    <ToggleButtons onChange={onChange} value={value}>
      {options.map(opt => {
        if (opt.isDisabled) {
          return (
            <ToggleButtons.Option key={opt.type} id={opt.type} isDisabled={opt.isDisabled}>
              <Tooltip placement="top">
                <Tooltip.Content>{opt.tooltipContent}</Tooltip.Content>
                <Icon color="inactive">{cloneElement(iconMap[opt.type])}</Icon>
              </Tooltip>
            </ToggleButtons.Option>
          );
        }
        return (
          <ToggleButtons.Option key={opt.type} id={opt.type}>
            <Icon>{cloneElement(iconMap[opt.type])}</Icon>
          </ToggleButtons.Option>
        );
      })}
    </ToggleButtons>
  );
}

export { DataVizToggle, iconMap };
